
export enum AlertSeverity {
  CRITICAL = 'CRITICAL',
  HIGH = 'HIGH',
  MEDIUM = 'MEDIUM',
  LOW = 'LOW',
  INFO = 'INFO'
}

export enum AlertType {
  AML = 'AML Alert',
  SANCTIONS = 'Sanctions Hit',
  KYC = 'KYC Failure',
  LEI = 'Expired LEI',
  LEI_RENEWAL_REMINDER = 'LEI Renewal Reminder',
  FRAUD = 'Fraud Pattern',
  ESG_RISK = 'ESG Risk Signal',
  SENTIMENT_SPIKE = 'Negative Sentiment Spike'
}

export interface Alert {
  id: string;
  type: AlertType;
  severity: AlertSeverity;
  description: string;
  date: string;
  entity: string;
}

export interface ModuleStats {
  id: string;
  title: string;
  value: string | number;
  subValue?: string;
  trend?: number;
  status: 'valid' | 'warning' | 'error' | 'pending';
  cta: string;
  icon: string;
  meta?: any;
}

export type NavigationPage = 
  | 'dashboard' 
  | 'ekyc' 
  | 'kyb' 
  | 'kyi' 
  | 'aml' 
  | 'lei' 
  | 'blockchain' 
  | 'iban' 
  | 'phone' 
  | 'email' 
  | 'market'
  | 'darkweb'
  | 'alerts' 
  | 'settings' 
  | 'esg' 
  | 'contact'
  | 'reputation';

export type ViewMode = 'user' | 'admin';

export interface EntityKYC {
  id: string;
  name: string;
  type: 'Individual' | 'Corporate';
  status: 'Verified' | 'Pending' | 'Rejected';
  date: string;
  risk: 'Low' | 'Medium' | 'High';
}

export type SubscriptionTier = 'Free' | 'Pro' | 'Enterprise';
export type AuthState = 'landing' | 'login' | 'register' | 'pricing' | 'payment' | 'authenticated' | 'public-contact' | 'about' | 'demo' | 'use-cases';
